import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import AppShell from '../components/LayoutV2/AppShell';
import FloatingPlayer from '../components/Player/FloatingPlayer';
import CookieConsent from '../components/CookieConsent/CookieConsent';
import ScrollToTop from '../components/ScrollToTop';
import RouteMeta from '../components/RouteMeta';
import { routes, fallbackRoute } from './routes';

// Sonic Motion is a single-column design with no persistent side rail — the
// "Quick Links" SidebarNav doesn't appear anywhere in the approved mockup, so
// it's dropped here rather than reskinned. See
// .claude/skills/sonic-motion-redesign/SKILL.md.
const Layout = () => {
  const location = useLocation();

  return (
    <AppShell
      player={<FloatingPlayer />}
      headerProps={{}}
      footerProps={{}}
      activePath={location.pathname}
    >
      <Outlet />
    </AppShell>
  );
};

const NewLayoutApp = () => {
  return (
    <Router>
      <RouteMeta />
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          {routes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
          <Route path={fallbackRoute.path} element={fallbackRoute.element} />
        </Route>
      </Routes>
      <CookieConsent />
    </Router>
  );
};

export default NewLayoutApp;
